import { Sparkles, Leaf, Wrench } from "lucide-react";

/** Services métier (attribués aux easers via les tags Dolibarr « easer clean » / « easer green » / « easer handy »). */
export const SERVICES = {
  clean: { label: "Nettoyage", short: "Clean", cls: "bg-sky-100 text-sky-700", icon: Sparkles },
  green: { label: "Espaces verts", short: "Green", cls: "bg-emerald-100 text-emerald-700", icon: Leaf },
  handy: { label: "Homme toutes mains", short: "Handy", cls: "bg-amber-100 text-amber-700", icon: Wrench },
};

export const memberServices = (m) => (m?.services?.length ? m.services : ["clean"]);
export const hasService = (m, service) => memberServices(m).includes(service || "clean");

export const GREEN_PRESTATIONS = ["Tonte", "Taille de haies / arbustes", "Désherbage", "Débroussaillage", "Ramassage de feuilles", "Entretien de massifs", "Évacuation des déchets verts"];
export const HANDY_PRESTATIONS = ["Fixations (étagères, écrans, tableaux)", "Montage de mobilier", "Ampoules / néons", "Joints / petites réparations", "Manutention / débarras", "Retouches peinture", "Pose d'équipements"];
export const CLEAN_PRESTATIONS = ["Sols", "Sanitaires", "Vitres", "Poubelles", "Dépoussiérage", "Cuisine / salle de pause", "Consommables", "Base vie chantier", "Désinfection"];
export const prestationsFor = (service) => (service === "green" ? GREEN_PRESTATIONS : service === "handy" ? HANDY_PRESTATIONS : CLEAN_PRESTATIONS);

/** URL absolue d'une image de galerie (les photos CRM sont servies en /api/files/...). */
export const mediaUrl = (u) => (u && u.startsWith("/") ? `${process.env.REACT_APP_BACKEND_URL}${u}` : u);
